import { Fragment } from 'react';

import { VENUES_TAXONOMY_KEY } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import { WeddingDateField } from '~/components/common/form/WeddingDateField/WeddingDateField';
import { CouplesStorefrontDetails } from '~/types/storefrontDetails';

import { validateWeddingDateField } from '../../../../../components/common/form/WeddingDateField/validateWeddingDateField';
import { useInquiryValues } from '../../context/InquiryContext';
import { LoadedInquiryValues } from '../../context/types';
import { InquiryFormValues, MisMatchFunction } from '../../types';

const DATE_PARTS: (keyof InquiryFormValues)[] = ['weddingDay', 'weddingMonth', 'weddingYear'];

export const FIELD_NAMES: (keyof InquiryFormValues)[] = [...DATE_PARTS, 'flexibleOnDate'];

export const isAnswered = ({
  initialValues,
  storefront,
}: {
  initialValues: InquiryFormValues;
  storefront: CouplesStorefrontDetails;
}): boolean => {
  if (isVenue(storefront)) {
    return true;
  }

  return Boolean(initialValues.weddingMonth && initialValues.weddingYear);
};

export const isWeddingDateMisMatch: MisMatchFunction = ({ initialValues, storefront }) => {
  if (isVenue(storefront)) {
    return undefined;
  }

  if (isAnswered({ initialValues, storefront })) {
    const formValidationResult = validateWeddingDateField(initialValues);
    const passedFormValidation =
      formValidationResult.bookedDates === undefined &&
      formValidationResult.weddingDate === undefined;

    return passedFormValidation ? undefined : 'wedding-date';
  }
  return undefined;
};

const isVenue = (storefront: CouplesStorefrontDetails) => {
  return !isNonVenue(storefront);
};

export const isNonVenue = (storefront: CouplesStorefrontDetails) => {
  const { taxonomyKey } = storefront;
  return taxonomyKey !== VENUES_TAXONOMY_KEY;
};

export const LABEL = 'Wedding date (or month and year)';

export const NonVenueWeddingDate = ({
  forceErrorsVisible = false,
  showLabel = true,
}: {
  forceErrorsVisible?: boolean;
  showLabel?: boolean;
}) => {
  const { storefront } = useInquiryValues() as LoadedInquiryValues;

  if (isNonVenue(storefront)) {
    return (
      <WeddingDateField
        label={showLabel ? LABEL : undefined}
        forceErrorsVisible={forceErrorsVisible}
      />
    );
  }
  return <Fragment />;
};

const NonVenueWeddingDateField = {
  FIELD_NAMES,
  isAnswered,
  isMisMatch: isWeddingDateMisMatch,
};

export default NonVenueWeddingDateField;
